import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=6794c8e2&scoped=true"
import script from "./journal.vue?vue&type=script&lang=js"
export * from "./journal.vue?vue&type=script&lang=js"
import style0 from "./journal.vue?vue&type=style&index=0&id=6794c8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794c8e2",
  null
  
)

export default component.exports